export const updateFaviconAndManifest = (isAdmin) => {
  // Update favicon
  const favicon = document.querySelector("link[rel~='icon']");
  if (favicon) {
    favicon.href = isAdmin ? "/admin-favicon.ico" : "/favicon.ico";
  } else {
    const newFavicon = document.createElement("link");
    newFavicon.rel = "icon";
    newFavicon.href = isAdmin ? "/admin-favicon.ico" : "/favicon.ico";
    document.head.appendChild(newFavicon);
  }

  // Update manifest
  let manifest = document.querySelector("link[rel='manifest']");
  if (manifest) {
    manifest.href = isAdmin ? "/admin-manifest.json" : "/manifest.json";
  } else {
    const newManifest = document.createElement("link");
    newManifest.rel = "manifest";
    newManifest.href = isAdmin ? "/admin-manifest.json" : "/manifest.json";
    document.head.appendChild(newManifest);
  }
};
